<template>
  <div :class="$style.testWrapper" class="allow-scroll">
    <div v-if="!showResultPopup" :class="$style.test">
      <transition name="fade" mode="out-in" v-for="(question, index) in questions" :key="question.id">
        <div :class="$style.questionWrapper" v-if="index === currentQuestion">
          <div :class="$style.question">
            <span :class="$style.count">{{currentQuestion + 1}}/{{questionsCount}}</span>
            <span :class="$style.title">{{question.title}}</span>
            <div :class="$style.answers">
              <div :class="$style.textAnswerWrapper" v-if="question.type === 'text'">
                <div :class="$style.textAnswer"  v-for="(answer, answerId) in question.answers" :key="answerId">
                  <check-box :class="$style.checkBox" v-model="checked[answer.id]" @change="selectAnswer(answer.id, answer.value)"/>
                  <span :class="[$style.textAnswerDescription, 'pointer', {[$style.selected]: checkedAnswers === answer.id}]" @click="selectAnswer(answer.id, answer.value)">{{answer.title}}</span>
                </div>
              </div>
              <div :class="$style.imageAnswerWrapper" v-if="question.type === 'image'">
                  <div :class="[$style.imageAnswer, 'pointer', {[$style.selected]: checkedAnswers === answer.id}]" v-for="(answer, answerId) in question.answers" :key="answerId" @click="selectAnswer(answer.id, answer.value)">
                    <img :src="answer.url" :alt="answer.id">
                  </div>
              </div>
              <span v-if="question.type === 'image'" :class="$style.subtitle">Выбери одну из картинок</span>
            </div>
          </div>
          <transition name="fade">
            <button v-if="checkedAnswers" :class="$style.button" @click="buttonClick">Продолжить</button>
          </transition>
        </div>
      </transition>
    </div>
    <transition name="fade">
      <div v-if="showResultPopup" :class="$style.result">
        <img :src="result.img" :class="$style.img" alt="result">
        <span :class="$style.title">Ты - {{result.title}}</span>
        <span :class="$style.description">{{result.description}}</span>
        <div :class="$style.buttons">
          <button :class="$style.closeButton" @click="getCertificate">Получить сертификат</button>
          <button :class="[$style.closeButton, $style.shareButton]" @click="shareButtonClick">Поделиться в VK</button>
        </div>
      </div>
    </transition>
    <HelpBox
      ref="helpbox"
      :type="helpBox.type"
      :description="helpBox.description"
      :show="helpBox.show"
      :white="helpBox.white"
      :hideButton="true"
      warn-message="ОК"
      @close="helpBox.show=false"
      @closeWarning="helpBox.show=false"
      character="girl"
    />
  </div>
</template>

<script>
import questionsData from './data/questions.json'
import resultsData from './data/results'
import CheckBox from '@/components/CheckBox/checkBox'
import saveDataMixin from '@/mixins/saveData'
import HelpBox from '@/components/HelpBox/HelpBox'

export default {
  name: 'Test',
  components: { CheckBox, HelpBox },
  mixins: [saveDataMixin],
  data() {
    return {
      questions: questionsData,
      results: resultsData,
      checked: {},
      checkedAnswers: null,
      checkedValue: null,
      currentQuestion: 0,
      questionsCount: 10,
      resCoords: {
        inside: { x: 0, y: 0 },
        outside: { x: 0, y: 0 },
      },
      result: {},
      showResultPopup: false,
      helpBox: {
        description: 'Пройди тестирование, чтобы узнать, какая профессия тебе больше подходит.',
        show: false,
        type: 'task',
        character: 'girl',
        white: false,
      },
    }
  },
  methods: {
    buttonClick() {
      if (!this.checkedAnswers) return
      this.calcPosition()
      if (this.currentQuestion >= this.questionsCount - 1) {
        this.calcResult()
        return
      }
      this.checkedAnswers = null
      this.checked = {}
      this.currentQuestion += 1
    },
    selectAnswer(id, value) {
      const val = this.checkedAnswers
      this.checkedAnswers = null
      this.checked = {}
      if (val !== id) {
        this.checkedAnswers = id
        this.checked[id] = true
      }
      this.checkedValue = value
    },
    calcPosition() {
      const { location } = this.questions[this.currentQuestion]
      const { direction } = this.questions[this.currentQuestion]
      this.resCoords[location][direction] += this.checkedValue
    },
    calcResult() {
      const randomizer = [-1, 1]
      /* eslint-disable no-nested-ternary */
      this.resCoords.inside.x = this.resCoords.inside.x > 0 ? 1 : (this.resCoords.inside.x < 0 ? -1 : randomizer[Math.floor(Math.random() * randomizer.length)])
      this.resCoords.inside.y = this.resCoords.inside.y > 0 ? 1 : (this.resCoords.inside.y < 0 ? -1 : randomizer[Math.floor(Math.random() * randomizer.length)])
      this.resCoords.outside.x = this.resCoords.outside.x > 0 ? 1 : (this.resCoords.outside.x < 0 ? -1 : randomizer[Math.floor(Math.random() * randomizer.length)])
      this.resCoords.outside.y = this.resCoords.outside.y > 0 ? 1 : (this.resCoords.outside.y < 0 ? -1 : randomizer[Math.floor(Math.random() * randomizer.length)])
      this.result = this.results.find(x => x.global_x === this.resCoords.outside.x && x.global_y === this.resCoords.outside.y && x.local_x === this.resCoords.inside.x && x.local_y === this.resCoords.inside.y)
      this.showResultPopup = true
    },
    getCertificate() {
      this.saveData({})
    },
    shareButtonClick() {
      this.$emit('share')
      this.$vk.shareDefault({ image: this.result.shareImg, text: `Моя будущая профессия — ${this.result.title}! \n ${this.result.small}` })
    },
  },
  mounted() {
    this.helpBox.show = true
  },
}
</script>
<style lang="scss" module>
  @import './Test.scss';
</style>
